import { WidgetContentEntry } from '@vestico/model';

import { ContentDisplayContext } from './ContentDisplayContext';
import { ContentDisplayEvents } from './ContentDisplayEvents';
import { ContentDisplayMain } from './ContentDisplayMain';

export interface ContentDisplayLoaderProps {
  entry: WidgetContentEntry;
}

export const ContentDisplayLoader = ({ entry }: ContentDisplayLoaderProps) => {
  return (
    <ContentDisplayContext entry={entry}>
      <ContentDisplayEvents entry={entry}>
        <ContentDisplayMain entry={entry} />
      </ContentDisplayEvents>
    </ContentDisplayContext>
  );
};

export default ContentDisplayLoader;
